import { useEffect } from "react";
import { setPageSEO } from "@/lib/seo";
import { Toaster } from "@/components/ui/sonner";
import useReveal from "@/hooks/useReveal";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import PainPoints from "@/components/landing/PainPoints";
import WhatEOSAchieves from "@/components/landing/WhatEOSAchieves";
import SixComponents from "@/components/landing/SixComponents";
import BeforeAfter from "@/components/landing/BeforeAfter";
import TestimonialShowcase from "@/components/landing/TestimonialShowcase";
import WhatThisMeans from "@/components/landing/WhatThisMeans";
import StatsBanner from "@/components/landing/StatsBanner";
import WhyCarlos from "@/components/landing/WhyCarlos";
import FAQ from "@/components/landing/FAQ";
import BlogTeaser from "@/components/landing/BlogTeaser";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";
import CtaButton from "@/components/landing/CtaButton";
import WhatsAppFloat from "@/components/landing/WhatsAppFloat";

const HOME_VIDEO_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "VideoObject",
  "@id": "https://garcin.cl/#video-hero",
  name: "Te cuento qué es EOS en menos de 2 minutos ⏳",
  description:
    "Carlos Garcín, Professional EOS Implementer®, explica brevemente qué es EOS y cómo ayuda a los equipos de liderazgo a fortalecer la Visión, la Tracción y la Salud de su empresa.",
  uploadDate: "2026-07-29",
  thumbnailUrl: "https://i.ytimg.com/vi/EYwWG_I8v0I/maxresdefault.jpg",
  embedUrl: "https://www.youtube.com/embed/EYwWG_I8v0I",
  contentUrl: "https://www.youtube.com/watch?v=EYwWG_I8v0I",
  duration: "PT1M45S",
};

export default function Home() {
  useReveal();

  useEffect(() => {
    setPageSEO({
      title: "Carlos Garcín | Implementador EOS Chile y Latinoamérica",
      description: "Carlos Garcín, Implementador oficial EOS en Chile y Latinoamérica. Ayuda a empresarios a escalar con foco, alineamiento y disciplina usando EOS®.",
      path: "/",
      keywords: "EOS Chile, Implementador EOS, consultor EOS, Entrepreneurial Operating System, Carlos Garcín, EOS Latinoamérica, consultoría empresarial Chile, Professional EOS Implementer, testimonios EOS",
    });
  }, []);

  useEffect(() => {
    const hash = decodeURIComponent(window.location.hash.slice(1));
    if (!hash) return;
    const t = setTimeout(() => document.getElementById(hash)?.scrollIntoView({ block: "start" }), 300);
    return () => clearTimeout(t);
  }, []);

  return (
    <>
      <Header />
      <main className="home-main">
        <Hero />
        <PainPoints />
        <WhatEOSAchieves />
        <TestimonialShowcase cta={<CtaButton testId="mid-cta-1" className="items-start sm:items-end" />} />
        <BeforeAfter variant="home" />
        <WhatThisMeans />
        <WhyCarlos cta={<CtaButton testId="mid-cta-2" className="items-start sm:items-end" />} />
        <StatsBanner />
        <SixComponents />
        <FAQ />
        <BlogTeaser />
        <FinalCTA />
      </main>
      <Footer />
      <WhatsAppFloat />
      <Toaster position="top-right" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(HOME_VIDEO_SCHEMA) }} />
    </>
  );
}
